import { typographyStyles } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { ComponentProps } from 'react'

export const OverviewSection = ({
  children,
  className,
}: Pick<ComponentProps<'div'>, 'className' | 'children'>) => (
  <div
    className={cx(
      'flex flex-col flex-wrap items-start gap-1 min-w-fit',
      typographyStyles({ intensity: 'secondary' }),
      className,
    )}
  >
    {children}
  </div>
)
